import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { ContainerInformationProjectDetails } from "../../../../components/container/ContainerInformationProjectDetails";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import CardProjectFiche from "./CardProjectFiche";


const CardClient = ({ isSuperAdmin, isAdmin, client, activeModalDetailsProject }) => {
    return (
        <CardProjectFiche
            title="Cliente"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.client);
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="h-[240px] xl:h-[320px]">
                {client.map((data, index) => (
                    <div key={`${index}-proyect`} className="w-full">
                        <ContainerInformationProjectDetails className="h-[48px]" name="Nombre del Cliente:">
                            <div className="bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                                <span className="text-[10px]">{data.name}</span>
                            </div>
                        </ContainerInformationProjectDetails>
                        <ContainerInformationProjectDetails className="h-[48px]" name="Rol:">
                            <div className="bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                                <span className="text-[10px]">{data.rol}</span>
                            </div>
                        </ContainerInformationProjectDetails>
                        <ContainerInformationProjectDetails className="h-[48px]" name="Email:">
                            <div className="bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                                <span className="text-[10px]">{data.email}</span>
                            </div>
                        </ContainerInformationProjectDetails>
                    </div>
                ))}
            </div>
        </CardProjectFiche>
    );
};

export default CardClient;
